import RS from '~/api';
import { KEY_WIDGET_LAST_CHANGES } from '~/constants';
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from '~/helpers/storage';

export const checkTimingsWidgets = () => {

  return RS.widgetLastChanges.get().then((response) => {

    const newWidgetsLastChangesTime = response.payload[0]?.lastChanges;

    const widgetLastChangesTime: {
      oldTime?: number;
      newTime?: number;
    } = getFromLocalStorage(KEY_WIDGET_LAST_CHANGES, 'scenarios') || {};

    const newTime = widgetLastChangesTime?.newTime || 0;

    saveToLocalStorage(KEY_WIDGET_LAST_CHANGES, 'scenarios', {
      oldTime: newWidgetsLastChangesTime, newTime,
    });

  });

};
